import React from "react";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalCustomerRoute(props) {
  const customerRoute = props.model;

  return (
    <Modal
      title="Cliente Ruta"
      model={customerRoute}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/customer-route"
      state
    ></Modal>
  );
}
